export const inputVariant = "outlined";
//export const inputVariant = "standard";

//export const inputColor = "primary";
export const inputColor = "secondary";
